export const productos_mixin = {
  created(){
    if(this.productos.length == 0){
      this.getProductos()
    }
  },

  methods:{
    getProductos(){
      axios.get(`api/get-all-productos`).then(res => {
          this.$store.dispatch('setProductos', res.data)
      }, res => {
         this.$toast.error('Error cargando productos')
      })
    }
  },

  computed: {
    productos() {
      const productos = this.$store.getters.get_productos;
      // Aseguramos que cada producto tenga las propiedades necesarias y esté en el formato correcto
      return productos.map(producto => ({
        id: producto.id,
        nombre: producto.nombre || '',
        precio: parseFloat(producto.precio) || 0,
        minutos: parseInt(producto.minutos) || 0,
        descripcion: producto.descripcion || ''
      })).filter(producto => producto.nombre); // Filtramos productos sin nombre
    }
  }
}
